module.exports = "<h1>Your Order has been placed successfully</h1>"


//////////////////
// WEBPACK FOOTER
// C:/React/Antique/src/app/order-success/order-success.component.html
// module id = ../../../../../src/app/order-success/order-success.component.html
// module chunks = 1